import { useHistory, useParams } from "react-router";
import { BreadCrumb, Button, Link, Header } from "@funcional/react-ui";
import { Private, SsoRolesEnum } from "@funcional/react-auth-ui";
import { IntlDateTime } from "@funcional/react-intl-ui";
import {
  useDeleteProgramFamily,
  useProgramFamilies,
} from "@pbm/programs-families/hooks";
import { useMemo } from "react";
import { IProgramFamily } from "@pbm/programs-families/contracts";
import { Column } from "react-table";
import { GridView } from "@funcional/react-table-ui";

export default function ListProgramFamilyPage() {
  let { programCode }: { programCode: string } = useParams();
  const { mutateAsync } = useDeleteProgramFamily();
  const history = useHistory();
  const deleteRecord = async (row: any) => {
    if (!window.confirm("Tem certeza de que deseja excluir este registro?")) {
      return Promise.resolve(false);
    }
    try {
      await mutateAsync({
        programFamilyCode: row.original.code,
        programCode,
      } as any);
      return true;
    } catch (err) {
      console.error(err);
      return false;
    }
  };

  const editRecord = (row: any) =>
    history.push(
      `/pbm/programs/${programCode}/families/${row.original.code}/edit`
    );

  const showRecord = (row: any) =>
    history.push(`/pbm/programs/${programCode}/families/${row.original.code}`);

  const columns: Column<IProgramFamily>[] = useMemo(
    () => [
      {
        Header: "Código",
        accessor: "code",
        Cell: ({ value }) => (
          <Link to={`/pbm/programs/${programCode}/families/${value}`}>
            {value}
          </Link>
        ),
      },
      { Header: "Nome", accessor: "name" },
      {
        Header: "Política Cadastral",
        accessor: "registrationPolicy",
        Cell: ({ value }) => {
          if (!value) {
            return <>Nenhuma</>;
          }

          return (
            <Link to={`/pbm/registration-policies/${value.id}`}>
              {value.description}
            </Link>
          );
        },
      },
      {
        Header: "Início da Vigência",
        accessor: "effectiveSince",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
      {
        Header: "Fim da Vigência",
        accessor: "effectiveUntil",
        Cell: ({ value }) => <IntlDateTime value={value} />,
      },
    ],
    [programCode]
  );

  return (
    <>
      <Header
        title="Grupo de Produtos do Programa"
        buttons={
          <>
            <Private
              roles={[
                SsoRolesEnum.MASTER,
                SsoRolesEnum.SUPPORT,
                SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
              ]}
            >
              <Button
                variant="outlined"
                onClick={() =>
                  history.push(`/pbm/programs/${programCode}/edit`)
                }
              >
                Editar Programa
              </Button>
            </Private>

            <Private
              roles={[
                SsoRolesEnum.MASTER,
                SsoRolesEnum.SUPPORT,
                SsoRolesEnum.PHARMA_BENEFIT_MANAGER,
                SsoRolesEnum.RETAIL_PHARMA_BENEFIT_MANAGER,
              ]}
            >
              <Button
                color="primary"
                onClick={() =>
                  history.push(`/pbm/programs/${programCode}/families/new`)
                }
              >
                Novo Grupo de Produtos
              </Button>
            </Private>
          </>
        }
      >
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/pbm/programs", label: "Programas" },
            {
              path: `/pbm/programs/${programCode}`,
              label: programCode,
            },
            { label: "Grupos de Produtos" },
          ]}
        />
      </Header>

      <GridView<IProgramFamily>
        accessControlResourceName="families"
        deleteRecord={deleteRecord}
        editRecord={editRecord}
        showRecord={showRecord}
        columns={columns}
        defaultFilters={
          programCode ? [{ id: "programCode", value: programCode }] : []
        }
        hook={useProgramFamilies}
      />
    </>
  );
}
